import { render, staticRenderFns } from "./instance.vue?vue&type=template&id=2844ada5&scoped=true"
import script from "./instance.vue?vue&type=script&lang=js"
export * from "./instance.vue?vue&type=script&lang=js"
import style0 from "./instance.vue?vue&type=style&index=0&id=2844ada5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2844ada5",
  null
  
)

export default component.exports